import axios from 'axios'


export const createInstance = (URL) => {
  let baseURL = JSON.parse(localStorage.getItem('_system'))?.api
  if(baseURL){
    URL = baseURL
  }
  const instance = axios.create({
    baseURL: URL,
    withCredentials: false,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    headers: {
      'Accept': 'application/json, text/html',
      'Content-Type': 'application/json, image/apng',
    },
  });
instance.CancelToken = axios.CancelToken

instance.interceptors.request.use((request) => {
  request.headers['Authorization'] = `Bearer ${localStorage.getItem('_system_token') ? localStorage.getItem('_system_token') : localStorage.getItem('token')}`
  return request
})

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error)
  }
)
return instance;
}
const instance = createInstance();
// export default instance;
